import { useEffect, useState } from 'react';
import { api_url }   from '../../config';
import Center        from '../../components/Auth/Center';


function PaymentSuccess() {
	const [ error, setError ] = useState(false);

	useEffect(() => {
		const params = new URLSearchParams(window.location.search);
		const session_id = params.get(`session_id`);
		const email      = params.get(`email`);

		if(!session_id || !email) {
			setError(`Something went wrong with the payment process. Please contact support.`);
			return;
		}

		fetch(`${api_url}/activate_account`, {
			method : `POST`,
			body   : JSON.stringify({ session_id, email }),
			headers : {
				'Content-Type' : `application/json`
			}
		}).then(response => response.json()).then(async data => {
			setTimeout(() => {
				window.location = `/`;
			}, 2500);
		});
	}, []);

	return (
		<>
			{error ? <Center>{error}</Center> : (
				<Center>
					Account successfully activated.

					Redirecting to log in page...
				</Center>
			)}
		</>
	);
}

export default PaymentSuccess;
